export type ActiveMiniGame = { gameId: string; playerIds: string[] };
let current: ActiveMiniGame[] = [];
let expires = 0;

export function activeMiniGame(gameId: string, data: any): ActiveMiniGame[] {
  const ids = data?.active_player_ids;
  if (data?.game?.status !== 'playing' || !Array.isArray(ids) || ids.length !== 2 ||
      !ids.every(id => typeof id === 'string' && id.length > 0) || ids[0] === ids[1]) return [];
  return [{ gameId, playerIds: ids }];
}

export function setMiniGameActivity(matches: ActiveMiniGame[]) {
  current = matches;
  expires = Date.now() + 10000;
}

export function playingMiniGame(userId: string, online?: Set<string>): string | undefined {
  if (Date.now() >= expires) return undefined;
  return current.find(match => match.playerIds.includes(userId) &&
    (!online || match.playerIds.every(id => online.has(id))))?.gameId;
}
